import React from "react";
import { renderToReadableStream, renderToString } from 'react-dom/server.browser';

export async function renderContentToHtmlString(content: React.ReactNode) {
	if (content) {
		return Promise.resolve(renderToString(content));
	}

	return Promise.resolve('');
}

export async function renderContentToHtmlStringStream(content: React.ReactNode) {
	if (content) {
		const renderer = async () => {
			const stream = await renderToReadableStream(content, {
				onError(error: any) {
					console.error(error);
				}
			});
			await stream.allReady; // wait for all the content including children to render
			return new Response(stream);
		};

		let response = await renderer();
		return await response.text();
	}

	return Promise.resolve('');
}
